// extracted by mini-css-extract-plugin
export default {"countdown":"CountdownTimer_countdown__v-6Cp","pulse":"CountdownTimer_pulse__mKm-m"};